import { Icon, IconProps, useTheme } from "@chakra-ui/react";
import React from "react";

type EmptyBrowserIconProps = IconProps & {
  colorScheme?: string;
};

export const EmptyBrowserIcon: React.FC<EmptyBrowserIconProps> = ({
  colorScheme = "gray",
  ...styles
}) => {
  const { colors } = useTheme();
  const palette = colors[colorScheme] ?? colors.gray;

  return (
    <Icon w="60" h="auto" viewBox="0 0 240 180" fill="none" {...styles}>
      <g
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke={palette[200]}
      >
        <path d="M10.3574 89.7168V91.7027" />
        <path d="M5.89844 90.793L7.52119 92.4634" />
        <path d="M4 95.2397H6.29455" />
        <path d="M5.71289 99.7657L7.33564 98.0952" />
        <path d="M10.3574 100.308V98.3223" />
        <path d="M13.6677 98.9846L12.3438 97.6606" />
        <path d="M16.316 95.6748H14.3301" />
        <path d="M14.9919 91.041L13.668 92.3649" />
        <path d="M116.934 3V4.32392" />
        <path d="M113 7H114.324" />
        <path d="M116.934 10.9436V9.61963" />
        <path d="M120.244 6.97168H118.92" />
        <path d="M40.1465 58.605V60.5909" />
        <path d="M34.1895 64.5625H36.1753" />
        <path d="M40.1465 69.858V67.8721" />
        <path d="M45.4429 64.5625H43.457" />
        <path d="M182.636 130.784C184.218 130.784 185.501 132.068 185.501 133.65C185.501 135.233 184.218 136.516 182.636 136.516C181.054 136.516 179.771 135.233 179.771 133.65" />
      </g>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          d="M195.748 104.785C197.449 104.255 200.057 102.174 200.66 99.936C201.208 101.915 203.502 104.255 205.573 104.432C203.242 105.257 201.014 107.709 200.66 109.634C200.42 107.671 197.338 105.072 195.748 104.785Z"
          fill={palette[100]}
        />
        <path
          d="M21.1309 129.901C21.9817 129.636 23.2849 128.596 23.5867 127.477C23.8604 128.466 25.0074 129.636 26.0425 129.725C24.8776 130.137 23.7637 131.363 23.5867 132.326C23.4664 131.344 21.9255 130.044 21.1309 129.901Z"
          fill={palette[100]}
        />
        <path
          d="M236.693 33.7215C236.693 35.3488 235.374 36.6676 233.748 36.6676C232.121 36.6676 230.803 35.3488 230.803 33.7215C230.803 32.0941 232.121 30.7754 233.748 30.7754C235.374 30.7754 236.693 32.0941 236.693 33.7215Z"
          fill={palette[100]}
        />
        <path
          d="M36.9196 37.8173C36.9196 39.045 35.9249 40.0394 34.6981 40.0394C33.4707 40.0394 32.4766 39.045 32.4766 37.8173C32.4766 36.5902 33.4707 35.5952 34.6981 35.5952C35.9249 35.5952 36.9196 36.5902 36.9196 37.8173Z"
          fill={palette[200]}
        />
        <g
          strokeOpacity="0.9"
          strokeWidth="1.5"
          strokeLinecap="round"
          stroke={palette[200]}
        >
          <path d="M78.4376 171.315C78.4376 172.341 77.6064 173.173 76.5808 173.173C75.5558 173.173 74.7246 172.341 74.7246 171.315C74.7246 170.289 75.5558 169.458 76.5808 169.458C77.6064 169.458 78.4376 170.289 78.4376 171.315Z" />
          <path d="M77.3336 23.5419C77.3336 24.7696 76.3389 25.764 75.1121 25.764C73.8853 25.764 72.8906 24.7696 72.8906 23.5419C72.8906 22.3148 73.8853 21.3198 75.1121 21.3198C76.3389 21.3198 77.3336 22.3148 77.3336 23.5419Z" />
          <path d="M209.729 160.322C208.309 160.863 206.721 160.149 206.181 158.73C205.64 157.31 206.353 155.72 207.773 155.181C209.192 154.64 210.781 155.353 211.321 156.773C211.862 158.193 211.148 159.782 209.729 160.322Z" />
        </g>
        <g fill={palette[100]}>
          <path d="M137.911 17.8649C138.677 17.9837 139.171 18.675 139.014 19.409L137 28.8317C136.844 29.5657 136.095 30.0644 135.329 29.9457C134.563 29.8269 134.069 29.1356 134.226 28.4016L136.239 18.9789C136.396 18.2449 137.145 17.7462 137.911 17.8649Z" />
          <path d="M144.42 44.6865C144.58 43.8406 145.298 43.2677 146.024 43.407L155.349 45.1956C156.076 45.3349 156.535 46.1336 156.375 46.9795C156.216 47.8255 155.497 48.3983 154.771 48.259L145.446 46.4704C144.72 46.3311 144.26 45.5324 144.42 44.6865Z" />
          <path d="M119.569 21.0691C120.199 20.6206 121.027 20.767 121.419 21.3962L126.428 29.4437C126.82 30.0729 126.627 30.9465 125.997 31.395C125.367 31.8435 124.539 31.697 124.147 31.0678L119.138 23.0203C118.746 22.3912 118.939 21.5175 119.569 21.0691Z" />
          <path d="M153.23 28.3477C153.622 28.9769 153.428 29.8505 152.798 30.299L144.741 36.0353C144.111 36.4838 143.282 36.3373 142.891 35.7082C142.499 35.079 142.692 34.2054 143.322 33.7569L151.38 28.0205C152.01 27.572 152.838 27.7185 153.23 28.3477Z" />
        </g>
      </g>
      <path
        d="M175.222 61.4357C178.956 62.4363 181.172 66.2747 180.171 70.0089L158.807 149.743C157.884 153.187 154.327 155.226 150.862 154.298L48.2722 126.809C44.807 125.88 42.7464 122.336 43.6692 118.892L65.034 39.158C66.0346 35.4237 69.8729 33.2076 73.6072 34.2082L175.222 61.4357Z"
        fill={palette[100]}
      />
      <path
        d="M73.1331 34.0282L175.723 61.5171C179.188 62.4456 181.243 66.0104 180.313 69.4803L178.96 74.5307L63.8228 43.6797L65.1761 38.6293C66.1058 35.1595 69.6679 33.0997 73.1331 34.0282Z"
        fill={palette[200]}
      />
      <path
        d="M73.6252 42.4831C74.7057 42.7726 75.8166 42.129 76.1061 41.0485C76.396 39.9665 75.7554 38.8552 74.6749 38.5656C73.5958 38.2765 72.4838 38.9182 72.1939 40.0002C71.9044 41.0807 72.5462 42.194 73.6252 42.4831Z"
        fill={palette[50]}
      />
      <path
        d="M79.9826 44.1867C81.0616 44.4758 82.174 43.8326 82.4635 42.7521C82.7535 41.6701 82.1113 40.5584 81.0323 40.2693C79.9517 39.9797 78.8413 40.6218 78.5513 41.7038C78.2618 42.7843 78.902 43.8972 79.9826 44.1867Z"
        fill={palette[50]}
      />
      <path
        d="M86.34 45.8903C87.4206 46.1798 88.5315 45.5362 88.821 44.4557C89.1109 43.3737 88.4703 42.2624 87.3897 41.9729C86.3091 41.6833 85.1987 42.3254 84.9088 43.4075C84.6192 44.4879 85.2595 45.6008 86.34 45.8903Z"
        fill={palette[50]}
      />
      <path
        d="M108.438 49.6646L137.347 57.411"
        stroke={palette[50]}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86.7452 72.0921L109.836 78.2793C111.304 78.6725 112.179 80.1908 111.785 81.6617C111.391 83.1312 109.874 84.0084 108.406 83.6152L85.3155 77.428C83.8465 77.0344 82.9713 75.5161 83.365 74.0467C83.7591 72.5757 85.2762 71.6984 86.7452 72.0921Z"
        fill={palette[300]}
      />
      <path
        d="M83.7902 83.1209L97.2887 86.7378C98.7577 87.1314 99.6329 88.6497 99.2392 90.1191C98.8451 91.5901 97.3279 92.4673 95.8589 92.0737L82.3604 88.4568C80.8914 88.0632 80.0162 86.5449 80.4103 85.0739C80.8041 83.6045 82.3212 82.7272 83.7902 83.1209Z"
        fill={palette[200]}
      />
      <path
        d="M106.171 89.1175L110.433 90.2595C111.902 90.6531 112.777 92.1714 112.384 93.6408C111.99 95.1118 110.472 95.989 109.003 95.5954L104.741 94.4534C103.272 94.0598 102.397 92.5415 102.791 91.0705C103.185 89.6011 104.702 88.7238 106.171 89.1175Z"
        fill={palette[300]}
      />
      <path
        d="M80.837 94.1477L84.1527 95.0362C85.6202 95.4294 86.4954 96.9476 86.1017 98.4171C85.7075 99.8881 84.1904 100.765 82.723 100.372L79.4073 99.4837C77.9383 99.09 77.0631 97.5718 77.4572 96.1008C77.8509 94.6314 79.368 93.7541 80.837 94.1477Z"
        fill={palette[200]}
      />
      <path
        d="M93.0308 97.4149L112.925 102.745C114.394 103.139 115.269 104.657 114.875 106.127C114.481 107.598 112.964 108.475 111.495 108.081L91.6011 102.751C90.1336 102.358 89.2584 100.839 89.6525 99.3684C90.0462 97.8989 91.5634 97.0217 93.0308 97.4149Z"
        fill={palette[300]}
      />
      <path
        d="M121.808 105.126L138.859 109.695C140.327 110.088 141.202 111.607 140.808 113.076C140.414 114.547 138.897 115.424 137.43 115.031L120.378 110.462C118.909 110.069 118.034 108.55 118.428 107.079C118.822 105.61 120.339 104.733 121.808 105.126Z"
        fill={palette[50]}
      />
      <path
        d="M77.882 105.175L88.5396 108.03C90.0071 108.423 90.8823 109.942 90.4881 111.413C90.0944 112.882 88.5773 113.759 87.1098 113.366L76.4522 110.511C74.9832 110.117 74.108 108.599 74.5017 107.129C74.8959 105.658 76.413 104.781 77.882 105.175Z"
        fill={palette[300]}
      />
      <path
        d="M97.4195 110.41L99.7887 111.044C101.256 111.438 102.131 112.956 101.737 114.427C101.344 115.896 99.8264 116.773 98.3589 116.38L95.9897 115.745C94.5223 115.352 93.647 113.834 94.0408 112.365C94.4349 110.894 95.952 110.016 97.4195 110.41Z"
        fill={palette[200]}
      />
      <path
        d="M108.669 113.424L122.761 117.2C124.229 117.593 125.104 119.111 124.71 120.582C124.316 122.052 122.799 122.929 121.332 122.536L107.24 118.76C105.772 118.366 104.897 116.848 105.291 115.379C105.685 113.908 107.202 113.03 108.669 113.424Z"
        fill={palette[300]}
      />
      <g style={{ mixBlendMode: "multiply" }} opacity="0.8">
        <path
          d="M168.518 87.0221C177.381 90.6741 187.528 86.4398 191.181 77.5639C194.835 68.6881 190.613 58.5322 181.749 54.8802C172.886 51.2281 162.739 55.4625 159.086 64.3383C155.432 73.2142 159.655 83.3701 168.518 87.0221Z"
          fill={palette[300]}
        />
      </g>
      <path
        d="M170.176 83.7067C179.039 87.3587 189.186 83.1244 192.84 74.2485C196.493 65.3726 192.271 55.2168 183.408 51.5647C174.544 47.9127 164.398 52.147 160.744 61.0229C157.09 69.8988 161.313 80.0547 170.176 83.7067Z"
        fill={palette[200]}
      />
      <path
        d="M180.096 58.7562L180.071 58.7445C178.345 58.0835 174.643 57.8856 172.995 61.8908C172.683 62.6461 173.04 63.5078 173.796 63.8195C174.55 64.1308 175.412 63.771 175.723 63.0157C176.622 60.8329 178.446 61.3018 178.998 61.4992C180.736 62.2264 181.431 63.6072 180.806 65.1286C180.344 66.2458 179.716 66.4594 178.175 66.7398C176.799 66.9864 174.712 67.3737 173.799 69.8105L173.636 70.207C173.325 70.9623 173.682 71.824 174.438 72.1357C175.185 72.4434 176.049 72.096 176.379 71.3472L176.577 70.866C176.88 70.0555 177.343 69.905 178.711 69.6544L178.733 69.6535C180.198 69.3828 182.419 68.9605 183.534 66.2534C184.793 63.1945 183.383 60.11 180.096 58.7562Z"
        fill={palette[50]}
      />
      <path
        d="M173.914 73.648C173.082 73.306 172.125 73.7045 171.781 74.5387C171.438 75.3718 171.837 76.3307 172.669 76.6742C173.514 77.0114 174.468 76.6202 174.803 75.7835C175.145 74.9489 174.747 73.992 173.914 73.648Z"
        fill={palette[50]}
      />
    </Icon>
  );
};
